import { TutorLevel } from '~/types/booking'

import TutorLevelItem from './TutorLevelItem'

export default function TutorLevels({
  selectedLevel,
  onClick,
}: {
  selectedLevel: TutorLevel
  onClick: (tutorLevel: TutorLevel) => void
}): React.ReactElement {
  return (
    <div className="grid grid-cols-2 gap-x-2">
      {Object.values(TutorLevel).map((elem) => (
        <TutorLevelItem isSelected={selectedLevel === elem} key={elem} onClick={onClick} value={elem} />
      ))}
      <span
        className={`col-span-2 scale-x-50 h-0.5 rounded-full transition-transform origin-left duration-300 bg-purple ${
          selectedLevel === TutorLevel.TUTOR ? 'mr-2 translate-x-0' : 'ml-2 translate-x-1/2'
        }`}
      />
    </div>
  )
}
